import {
    CalendarFormsRibbonId,
    CalendarFormsRibbonTabId,
    CalendarFormsRibbonGroupId,
    CalendarFormsRibbonControlId,
} from './calendarFormsRibbonId';
import {
    CalendarRibbonId,
    CalendarRibbonTabId,
    CalendarRibbonGroupId,
    CalendarRibbonControlId,
} from './calendarRibbonId';
import { FormatControlId } from './formatControlId';
import { ActionControlId } from './actionControlId';
import {
    MailRibbonId,
    MailRibbonTabId,
    MailRibbonGroupId,
    MailRibbonControlId,
} from './mailRibbonId';

/**
 * RibbonId is the most generic type, signaling any Id for any possible Ribbon element (tab/group/control).
 * RibbonId ranges:
 *     - MailRibbonId [0, 1999]
 *     - CalendarRibbonId [2000, 3999],
 *     - CalendarFormsRibbonId [4000, 5999],
 *     - FormatControlId [6000, 6999]
 *     - ActionControlId [7000, 7999]
 */
export type RibbonId =
    | MailRibbonId
    | CalendarRibbonId
    | CalendarFormsRibbonId
    | FormatControlId
    | ActionControlId;

/**
 * RibbonTabId is a sub-type to specify RibbonIds related to specifically tab components.
 */
export type RibbonTabId = MailRibbonTabId | CalendarRibbonTabId | CalendarFormsRibbonTabId;

/**
 * RibbonGroupId is a sub-type to specify RibbonIds related to specifically group components.
 */
export type RibbonGroupId = MailRibbonGroupId | CalendarRibbonGroupId | CalendarFormsRibbonGroupId;

/**
 * RibbonControlId is a sub-type to specify RibbonIds related to specifically control components.
 */
export type RibbonControlId =
    | MailRibbonControlId
    | CalendarRibbonControlId
    | CalendarFormsRibbonControlId
    | FormatControlId
    | ActionControlId;

// The following variable is to be the maximum enum number for RibbonIds.
// It is used to determine between engineer-created groups and user-defined groups.
// Be sure to update this variable if ever adding an entirely new RibbonId range.
export const __MAX_RIBBON_ID = 8000;

export const getStringRibbonId = (id: RibbonId) => id.toString();
